export default function languageContent() {
    return [
        {
            // Messages - EN
            "loading": "Wait a few seconds. Your browser is downloading some tools.",
            "simulationRunningPOne": "The simulation $1 of $2 is being run on our server.",
            "simulationRunningPTwo": "Please, wait some minutes.",
            "maximizeButton": "Maximize WebCrowds Simulation Builder",
            "informationSimulation": "Information about simulation:",
            "serverInternalError": "Our server returned an error. Please, run the scene again in a few minutes.",
            "simulationTime": "Simulation Time:",
            "loadingProgress" : "Loading Progress",
            "errorAlreadySimulating": "Wait for the simulation to finish before performing another simulation.",

            // Words - EN
            "simulation": "Simulation",
            "seconds": "seconds",
        },
        {
            // Messages - PT_BR
            "loading": "Aguarde alguns segundos. Seu navegador está baixando algumas ferramentas.",
            "simulationRunningPOne": "A simulação $1 de $2 está rodando em nosso servidor.",
            "simulationRunningPTwo": "Por favor, aguarde alguns minutos.",
            "maximizeButton": "Maximize o Construtor de Simulações do WebCrowds",
            "informationSimulation": "Informações sobre a simulação:",
            "serverInternalError": "Nosso servidor retornou um erro. Por favor, rode a cena novamente em alguns minutos.",
            "simulationTime": "Tempo de Simulação:",
            "loadingProgress" : "Progresso do Carregamento",
            "errorAlreadySimulating": "Aguarde a simulação ser finalizada para realizar outra simulação",

            // Words - PT_BR
            "simulation": "Simulação",
            "seconds": "segundos",
        }
    ]
}